import React, { useState } from 'react';
import { EditorState } from 'draft-js';
import CommentTextEditorV2, {
  getContentState } from
'../../CommentTextEditorV2';
import { getCurrentUserId, parseJSON } from '../../../../../common/utils';
import '../styles/_add-reply.scss';















const AddReplyV2 = (props) => {
  const {
    parentComment: { isResolved, metadata: parentMetadata },
    visible = true,
    resourceOrganisationId,
    onInputFocus,
    onClose,
    hideTimestamp,
    hideVisibility
  } = props;

  const hasCurrentUserId = !!getCurrentUserId();

  const {
    commentOrigin,
    visibility,
    page,
    timestamp,
    internalMode
  } = parseJSON(parentMetadata || '');

  const resetEditorState = () => EditorState.createEmpty();
  const [editorState, setEditorState] = useState(resetEditorState());
  const [assetIds, setAssetIds] = useState([]);

  const nonInternalVisibility = ['PUBLIC', 'INTERNAL'];

  const getMetadata = () => JSON.stringify({
    commentOrigin,
    page,
    visibility,
    timestamp,
    internalMode,
    ...(visibility && nonInternalVisibility.includes(visibility) ? { internalMode: false } : {})
  });

  const onFilesChange = (updatedAssetIds) => {
    setAssetIds(updatedAssetIds);
  };

  const handleAddReply = async (e) => {
    e.stopPropagation();

    const {
      createReply,
      replyRef,
      parentComment,
      parentComment: { commentId: parentCommentId },
      shotId,
      sceneId
    } = props;

    const { json, plainText } = getContentState(editorState);

    if (!plainText.trim()) {return;}

    await createReply(
      {
        input: {
          content: json,
          parentId: parentCommentId,
          shotId,
          sceneId,
          metadata: getMetadata(),
          assetIds
        },
        parentComment
      }
    );

    onClose();
    setEditorState(resetEditorState());

    if (replyRef) {
      replyRef.scrollTo({ top: replyRef.scrollHeight, behavior: 'smooth' });
    }
  };

  return visible ?
  <div className="add-reply">
      <CommentTextEditorV2
      placeholder="Reply in thread..."
      editorState={editorState}
      onUpdateContent={setEditorState}
      onSave={handleAddReply}
      disabled={isResolved}
      organisationId={resourceOrganisationId}
      onFocus={onInputFocus}
      setFocusOnMount={hasCurrentUserId}
      assetIds={assetIds}
      onFilesChange={onFilesChange}
      onBlur={onClose}
      visibility={visibility}
      timestamp={timestamp}
      hideTimestamp={hideTimestamp}
      hideVisibility={hideVisibility} />

    </div> :
  null;
};

export default AddReplyV2;